var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.inputComponent === "v-text-field"
        ? _c("v-text-field", {
            attrs: {
              dense: "",
              type: _vm.schema.type,
              suffix: _vm.schema.unit,
            },
            model: {
              value: _vm.computedValue,
              callback: function ($$v) {
                _vm.computedValue = $$v
              },
              expression: "computedValue",
            },
          })
        : _vm._e(),
      _vm.inputComponent === "v-switch"
        ? _c("v-switch", {
            staticClass: "mt-0",
            attrs: { dense: "" },
            model: {
              value: _vm.computedValue,
              callback: function ($$v) {
                _vm.computedValue = $$v
              },
              expression: "computedValue",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }